module.exports = __webpack_public_path__ + "static/media/move.289befa3.svg";